import React from 'react';
import Radio from '@mui/material/Radio';

const RadioButton = ({ style = {}, ...props }) => {
  return (
    <Radio
      {...props}
      style={{ ...style, padding: '0px' }}
      disableRipple
      checkedIcon={
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <rect x="1" y="1" width="10" height="10" rx="5" fill="white" />
          <rect x="1" y="1" width="10" height="10" rx="5" stroke="#194BFB" stroke-width="2" />
        </svg>
      }
      icon={
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <rect x="1" y="1" width="10" height="10" rx="5" fill="white" />
          <rect x="1" y="1" width="10" height="10" rx="5" stroke="#A3A6AB" stroke-width="2" />
        </svg>
      }
    />
  );
};

export default RadioButton;
